(() => {
  'use strict';

  if (customElements.get('altruan-liefer-timeline')) return;

  const URGENT_MS = 60 * 60 * 1000;
  const REFETCH_GUARD_MS = 10 * 1000;
  const BAR_REFERENCE_MS = 24 * 60 * 60 * 1000;

  class AltruanLieferTimeline extends HTMLElement {
    connectedCallback() {

      this.dateEls = this.querySelectorAll('[data-liefer-date]');
      this.separator = this.getAttribute('data-liefer-sep') || 'und';

      const dataEl = this.querySelector('script[data-liefer-data]');
      if (!dataEl) return;

      try {
        this.config = JSON.parse(dataEl.textContent);
      } catch (_) {
        return;
      }

      this.dateEls = this.querySelectorAll('[data-liefer-date]');
      this.countdownEl = this.querySelector('[data-liefer-countdown]');
      this.barEl = this.querySelector('[data-liefer-bar]');

      this.deadline = null;
      this.lastFetch = 0;

      this.load();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    async load() {
      const now = Date.now();
      if (now - this.lastFetch < REFETCH_GUARD_MS) return;
      this.lastFetch = now;

      try {
        const shopify = window.Shopify || {};
        const response = await fetch(this.config.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'ngrok-skip-browser-warning': 'true',
          },
          body: JSON.stringify({
            country: shopify.country || this.config.country,
            locale: shopify.locale || this.config.locale,
            variant_id: Number(this.config.defaultVariantId),
            total_inventory: this.config.totalInventory,
            variant_always_available: this.config.alwaysAvailable,
          }),
        });

        if (!response.ok) return this.fallback();
        const data = await response.json();
        if (!data.date || !data.time) return this.fallback();

        this.applyDate(data.from_date, data.date);
        this.applyTime(data.time);
        this.classList.remove('is-loading', 'is-fallback');
      } catch (_) {
        this.fallback();
      }
    }

    applyDate(fromDate, toDate) {
      if (!this.dateEls || this.dateEls.length === 0) return;
      const from = (fromDate || '').trim();
      const to = (toDate || '').trim();
      const text = from && to ? `${from} ${this.separator} ${to}` : (to || from);
      this.dateEls.forEach(el => {
        el.textContent = text;
      });
    }

    applyTime(timeStr) {
      const match = /(\d+)\s*[:.](\d+)/.exec(timeStr || '');
      if (!match) {
        if (this.countdownEl) this.countdownEl.closest('p').hidden = true;
        if (this.barEl) this.barEl.hidden = true;
        this.deadline = null;
        return;
      }
      const ms = (Number(match[1]) * 60 + Number(match[2])) * 60 * 1000;
      this.deadline = Date.now() + ms;
      if (this.countdownEl) this.countdownEl.closest('p').hidden = false;
      if (this.barEl) this.barEl.hidden = false;
      this.tick();
    }

    tick() {
      if (!this.deadline) return;
      const rest = this.deadline - Date.now();

      if (rest <= 0) {
        this.deadline = null;
        this.lastFetch = 0;
        this.load();
        return;
      }

      const pad = (n) => String(n).padStart(2, '0');
      const h = Math.floor(rest / 3600000);
      const m = Math.floor((rest % 3600000) / 60000);
      const s = Math.floor((rest % 60000) / 1000);
      if (this.countdownEl) this.countdownEl.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;

      if (this.barEl) {
        const pct = Math.max(1, Math.min(100, (rest / BAR_REFERENCE_MS) * 100));
        this.barEl.style.setProperty('--liefer-remaining', `${pct}%`);
      }

      this.classList.toggle('is-urgent', rest < URGENT_MS);
    }

    fallback() {
      this.classList.remove('is-loading');
      this.classList.add('is-fallback');
      this.deadline = null;
    }
  }

  customElements.define('altruan-liefer-timeline', AltruanLieferTimeline);
})();